export class WpetInteractiveMap {
    
    constructor()
    {
        this.initializeMap();
    }

    initializeMap()
    {
        // Filters
        $('.wpet-imap__filter .wrapper_wpet_facets_item_title').on('click', function(e) {
            e.preventDefault();

            $(this).closest('.wrapper_wpet_facets_item').toggleClass('is-active');
        });

        $('.js-wpet-imap-filters').on('click', function(e) {
            e.preventDefault();

            $('body').toggleClass('is-wpet-imap-filters-open');
        });

        // Center position
        $('.js-center-position').on('click', function(e) {
            e.preventDefault();

            getUserPosition();
        });

        /**
         * Récupère la position de l'utilisateur
         */
        var position;

        function getUserPosition() {

            if (navigator.geolocation) {
                position = navigator.geolocation.getCurrentPosition( positionSuccess, null, {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 10
                });
            }
        }

        /**
         * Callback pour la récupération de la position de l'utilisateur
         */
        function positionSuccess(position) {

            if ( typeof position.coords != 'undefined' ) {
                if ( typeof position.coords.latitude != 'undefined' ) {
                    var latlng = new window.wpet_map_object.mapAdapter.LatLng(position.coords.latitude, position.coords.longitude);

                    var markerPosition = new window.wpet_map_object.mapAdapter.Marker(
                        latlng,
                        wpet_map_object.map,
                        Theme.themeURL + '/assets/dist/images/markers/marker-user.png'
                    );

                    markerPosition.setInfoWindow(
                        '<div class="infoBoxContent">'+
                        '<p>' + Theme.translate.you_are_here + '</p>'+
                        '</div>',
                        {
                            closeBoxURL: Theme.themeURL + '/assets/images/dist/markers/close-dark.png',
                        }
                    );

                    wpet_map_object.mapObject.setCenter( latlng );
                }
            }
        }
    }
}